import { Component, OnInit, ViewChild, Input, ViewEncapsulation, OnDestroy, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';


//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';

//import components
import { ServicingCreateComponent } from '../../servicing-create/servicing-create.component';

import { ServicingMaintenance } from '../../servicing-maintenance/servicing-maintenance.component';

//import { ServicingCalendarComponent } from '../servicing-calendar/servicing-calendar.component';


//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

declare var $: any;

@Component({
  selector: 'app-servicing-viewservice',
  templateUrl: './servicing-viewservice.component.html',
  styleUrls: ['./servicing-viewservice.component.css'],
  encapsulation: ViewEncapsulation.None

})

export class ServicingViewserviceComponent implements OnDestroy, OnInit {
  getPhotoBase64;

  @ViewChild('FormServModel') FormServModel: ElementRef;


  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;
  modalTitle: string;

  //common data
  data: any;


  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;

  lang: any;
  mLang: any;
  maintenanceData: any;
  records: any;

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  title = 'datatables';
  dtOptions: DataTables.Settings = {};
  modalRef: BsModalRef;

  constructor(
    private servicingService: ServicingService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    public bsmodalRef: BsModalRef,
    private generalService: GeneralService,

  ) { }


  ngOnInit() {
    this.data = [];

    this.getData();

    this.dtOptions = {
      paging: false,
      processing: true
    };
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any): void => {
      let currentTarget = args.target.closest('modal-lgs');
      if (currentTarget === null) {
        this.bsmodalRef.hide();
          }
    }
  }
    

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  getData() {

    this.servicingService.getList()
      .subscribe(
        (res) => {
          // console.log('test');
          // this.lang = this.servicingService.listLang(res);
          // this.records = res.data.all_record;
          // this.modalTitle = this.lang.servicing;

          this.FormServList(res);

        }
      );

  }

  FormServList(res): void {  
    this.lang = this.servicingService.listLang(res);
    this.records = res.data.all_record;

    this.modalRef = this.modalService.show(this.FormServModel, { class: 'modal-lgs' });

  }



  closepop()
  {

    this.modalRef.hide();
    this.bsmodalRef.hide();

    $('.modal-lgs').css('width: 600px !important');

  }

}
